<section class="equipements" aria-label="État du matériel" [attr.aria-busy]="chargement()">
  @if (affichage() === 'groupes') {
    <h3 class="section-label">Matériel</h3>
  } @else {
    <header class="equipements-header">
      <h2>
        <span class="material-symbols-outlined" aria-hidden="true">developer_board</span>Équipements
        <span class="nombre">{{ cartes().length }}</span>
      </h2>
      @if (!chargement() && !erreur() && cartes().length > 0) {
        <span class="resume" [class.avec-defauts]="nombreEnDefaut() > 0">
          {{ nombreEnDefaut() }} en défaut
        </span>
      }
    </header>
  }
  @if (erreur()) {
    <p role="alert" class="erreur">{{ erreur() }}</p>
    <button type="button" (click)="reessayer()">Réessayer</button>
  }
  @if (inventairePartiel()) {
    <p>
      La liste complète des équipements n’est pas disponible. Les équipements connus sont affichés.
    </p>
  }
  <div class="materiels-contenu" [class.en-chargement]="chargement()">
    <app-spinner-overlay [visible]="chargement()" label="Chargement des défauts…" />
    <div [inert]="chargement()">
      @if (affichage() === 'groupes') {
        <app-materiel-groupes [cartes]="cartes()" [installationId]="installation().id" />
      } @else {
        <ul class="cartes">
          @for (carte of cartes(); track carte.idMateriel) {
            <li app-materiel-carte [carte]="carte"></li>
          }
        </ul>
      }
    </div>
  </div>
  @if (!chargement() && !erreur() && cartes().length === 0 && !inventairePartiel()) {
    <p>Aucun équipement renseigné.</p>
  }
</section>
